import { lazy } from 'react';

// React.lazy que recarrega a página uma vez se o arquivo da tela não existir mais.
// Acontece com o app aberto durante um deploy: o index.html antigo pede arquivos que o deploy novo removeu.
const CHAVE = 'recarregouPorDeploy';

export default function lazyComRecarga(importar) {
    return lazy(async () => {
        try {
            const modulo = await importar();
            sessionStorage.removeItem(CHAVE);
            return modulo;
        } catch (erro) {
            if (!sessionStorage.getItem(CHAVE)) {
                sessionStorage.setItem(CHAVE, '1');
                window.location.reload();
                return new Promise(() => {}); // a página vai recarregar
            }
            throw erro;
        }
    });
}
